import React, { useEffect } from 'react';
import styled from 'styled-components';
import UserGroupsFilters from './UserGroupsFilters';
import useUserGroups from './useUserGroups';
import { useAppSelector } from '../../../../redux/hooks';
import { selectOpenedModalType } from '../../../../redux/selectors/modal';
import { ModalSliceType } from '../../../../redux/slices/modal';
import PermissionToggleModal from '../../../PermissionControls/PermissionToggleModal';
import { ContentLoader } from '../../../../components/Loaders';
import UserGroupsTable from './UserGroupsTable';
import { useAnalytics } from '../../../../utils/analytics/useAnalytics';
import { pageViewed } from '../../../../utils/analytics/events/page/events';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const UserGroupsIndexRoute = () => {
  const isDisableUserGroupModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DisableUserGroup, ''),
  );
  const isEnableUserGroupModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.EnableUserGroup, ''),
  );

  const {
    loading,
    refetch,
    groups,
    total,
    searchTerm,
    setSearchTerm,
    groupTypes,
    setGroupTypes,
    statuses,
    setStatuses,
  } = useUserGroups();

  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'settings',
        name: 'groups',
        id: null,
      }),
    );
  }, [track]);

  return (
    <Container>
      <UserGroupsFilters
        total={total}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        groupTypes={groupTypes}
        setGroupTypes={setGroupTypes}
        statuses={statuses}
        setStatuses={setStatuses}
      />
      {loading ? <ContentLoader /> : <UserGroupsTable groups={groups} />}
      {(isEnableUserGroupModalOpen || isDisableUserGroupModalOpen) && (
        <PermissionToggleModal refetch={refetch} />
      )}
    </Container>
  );
};

export default UserGroupsIndexRoute;
